module.exports = __webpack_public_path__ + "img/圆形.8f516a91.svg";